export default {
    ActivityDetails: {
        title: "Events Reservation Records",
        search: "Search",
        txId: "Reservation ID",
        account: "Member Account",
        contact: "Contact Info",
        peopleNumber: "Number of People",
        dateStr: "Booking Date",
        timeNo: "Booking Time",
        pointsNumber: "Points Paid",
        status: "Status",
        statusValid: "Active",
        statusCancel: "Cancelled",
        remark: "Special Remark",
        adminRemark: "Admin Remark",
        cTime: "Reservation Time",
        action: "Actions",
        editRemark: "Edit Admin Remark",
        remarkDialogTitle: "Edit Admin Remark",
        remarkPlaceholder: "Please enter admin remark",
        cancel: "Cancel",
        save: "Save",
        emptyRemark: "Remark cannot be empty",
        saveSuccess: "Saved successfully",
        roomTitle: "Room Reservation Records",
        productTitle: "Product Reservation Records",
        store: "Store",
    },
    WalletList: {
        title: "Wallet Points Transactions",
        accountPlaceholder: "Enter member account",
        txId: "Record ID",
        type: "Type",
        typeRecharge: "Top up",
        typeDeduct: "Deduct",
        typeFood: "Dining",
        value: "Amount",
        amount: "Points",
        url: "Receipt",
        view: "View",
        remark: "Remark",
        operator: "Operator",
        createTime: "Created At",
        action: "Action",
        editRemark: "Edit Remark",
        remarkDialogTitle: "Edit Remark",
        remarkPlaceholder: "Enter remark",
        cancel: "Cancel",
        save: "Save",
        search: "Search",
        emptyRemark: "Remark cannot be empty",
        saveSuccess: "Saved successfully",
        admin_remark: "Admin Remark",
    },
    ReserveList: {
        title: "Product Reservation",
        accountPlaceholder: "Enter member account",
        txId: "Reservation ID",
        account: "Member Account",
        contact: "Contact Info",
        serialNumber: "Product SN",
        location: "Viewing Location",
        reserveDate: "Viewing Date",
        remark: "Special Remark",
        createTime: "Reservation Time",
        status: "Status",
        valid: "Active",
        cancelled: "Cancelled",
        action: "Action",
        editRemark: "Add Remark",
        remarkDialogTitle: "Edit Remark",
        remarkPlaceholder: "Enter remark text",
        cancel: "Cancel",
        save: "Save",
        search: "Search",
        emptyRemark: "Remark cannot be empty",
        saveSuccess: "Saved successfully",
    },
    SystemSetting: {
        title: "System Setting",
        wechat: "WeChat Contact",
        whatsapp: "WhatsApp Contact",
        name: "Name",
        number: "WeChat ID / Number",
        position: "Position",
        message: "Message Template",
        avatar: "Avatar",
        qrcode: "QR Code",
        uploadAvatar: "Upload Avatar",
        uploadQRCode: "Upload QR Code",
        save: "Save",
        saveSuccess: "Saved successfully",
        saveFailed: "Save failed",
        uploadSuccess: "Upload successful",
        uploadFailed: "Upload failed",
        contact: "Contact Information"
    },
    ProductManage: {
        title: "Product Management",
        addProduct: "Add Product",
        editProduct: "Edit Product",
        titleCH: "Name (Chinese)",
        titleEN: "Name (English)",
        coverCH: "Cover (Chinese)",
        coverEN: "Cover (English)",
        detailsCH: "Details (Chinese)",
        detailsEN: "Details (English)",
        summaryCH: "Summary (Chinese)",
        summaryEN: "Summary (English)",
        colorCH: "Color (Chinese)",
        colorEN: "Color (English)",
        materialCH: "Material (Chinese)",
        materialEN: "Material (English)",
        locationCH: "Location (Chinese)",
        locationEN: "Location (English)",
        serialNumber: "Serial Number",
        price: "Price",
        operator: "Operator",
        createTime: "Created Time",
        status: "Status",
        contentCH: "Details (Chinese)",
        contentEN: "Details (English)",
    },

    RoomManage: {
        title: "Room Management",
        addRoom: "Add Room",
        editRoom: "Edit Room",
        nameCH: "Room Name (Chinese)",
        nameEN: "Room Name (English)",
        coverCH: "Cover (Chinese)",
        coverEN: "Cover (English)",
        menus: "Menu List",
        operator: "Operator",
        createTime: "Created Time",
        menuNameCH: "Menu Name (Chinese)",
        menuNameEN: "Menu Name (English)",
        addMenuBlock: "Add Menu",
        delete: 'Delete menu',
        needCoverCH: "Please upload Chinese cover",
        needCoverEN: "Please upload English cover",
        needOneMenu: "At least one menu block is required",
        needMenuNameCH: "Please enter Chinese menu name",
        needMenuNameEN: "Please enter English menu name",
        needMenuImage: "Each menu must have at least one image",
        completeRequired: "Please complete the required fields first",

    },
    MemberActivity: {
        title: "Event Management",
        addActivity: "Add Event",
        editActivity: "Edit Event",
        type: "Event Type",
        typeText: "Article Only",
        typeNormal: "Regular Event",
        typeFood: "FnB Event",
        title_ch: "Title (Chinese)",
        title_en: "Title (English)",
        summary_ch: "Summary (Chinese)",
        summary_en: "Summary (English)",
        content_ch: "Content (Chinese)",
        content_en: "Content (English)",
        cover_ch: "Cover (Chinese)",
        cover_en: "Cover (English)",
        start_date: "Start Date",
        end_date: "End Date",
        max_people: "Max Daily Participants",
        points: "Required Points",
        contact: "Contact Info",
        location: "Location",
        menus_amount: "Menu Item Count",
        menus_price: "Menu Price",
        menus: "Menu List",
        menusPlaceholder: "Enter one dish per line",

        status: "Status",
        statusSaved: "Saved",
        statusPublish: "Published",
        statusUnpublish: "Unpublished",
        createTime: "Created At",
        operator: "Operator",

        operate: "Actions",
        edit: "Edit",
        publish: "Publish",
        unpublish: "Unpublish",

        cancel: "Cancel",
        confirm: "Confirm",
        modifyStatus: "Modify Status",

        addSuccess: "Added Successfully",
        editSuccess: "Edited Successfully",
        publishSuccess: "Published Successfully",
        unpublishSuccess: "Unpublished Successfully",
        operateSuccess: "Operation Successful",
        operateFail: "Operation Failed",
        UploadedFile: "Uploaded File",
        LianXiRen: "Contact Person",
        phonePlaceholder: "Please enter country code + phone number, e.g. +86 13800000000",
        PleaseEnterContent: 'Please enter content',
        reservations: 'View Reservations',
    },

    MemberBanner: {
        title: 'Banner Management',
        addBanner: 'Add Banner',
        editBanner: 'Edit Banner',
        type: 'Type',
        typeVideo: 'Video',
        typeText: 'Text',
        typeLink: 'File',
        url: 'File',
        status: 'Status',
        statusSaved: 'Saved',
        statusPublish: 'Publish',
        statusUnpublish: 'Unpublish',
        operate: 'Operate',
        edit: 'Edit',
        modifyStatus: 'Modify Status',
        confirm: 'Confirm',
        cancel: 'Cancel',
        addSuccess: 'Added Successfully',
        editSuccess: 'Edited Successfully',
        operateSuccess: 'Operation Successful',
        operateFail: 'Operation Failed',
        createTime: 'Create Time',
        operator: 'Operator',
        uploadProgress: "Uploading...",
        uploadText: "Upload",
        publish: "Publish",
        unpublish: "Unpublish",
        file: 'File',
        typeImage: "Image",
        uploadedFile: "Uploaded File",
        uploadSuccess: "Upload Success",
        uploadFail: "Upload Failed",
        deleteConfirm: "Are you sure to delete this file?",
        publishSuccess: "Banner published successfully",
        unpublishSuccess: "Banner unpublished successfully",
        delete: 'Delete',
        uploadTooLarge: "The image cannot exceed 10MB",
    },
    MainHeader: {
        chinese: "Chinese",
        english: "English",
        confirm: "Confirm",
        cancel: "Cancel",
        tip: "Notice",
        logoutConfirm: "Are you sure you want to log out?",
        logout: "Logout",
        username: "Username",
    },
    MainAside: {
        userList: "User List", // 用户列表
        ngpLockdown: "Lockdown List", // NGP封控列表
        systemUserManage: "System User Management", // 系统用户管理
        systemUser: "System User", // 系统用户
        rights: "Rights", // 权限
    },

    Login: {
        username: "Username",
        password: "Password",
        login: "Login",
        scanQRCode: "Please scan the QR code with Google Authenticator APP",
        nextStep: "Next",
        enterGoogleCode: "Enter your 6-digit Google Authenticator code",
        googleCode: "6-digits Code",
        confirm: "Confirm",
        enterUsername: "Please enter username",
        enterPassword: "Please enter password",
    },
    NgpLockdownList: {
        title: "Lockdown List",
        ipBlock: "IP Block",
        userBlock: "User Block",
        blockContent: "Block Content",
        search: "Search",
        clear: "Clear",
        action: "Action",
        unblock: "Unblock",
        confirmUnblock: "Confirm unblock?",
        tip: "Tip",
        confirm: "Confirm",
        cancel: "Cancel",
        unblockSuccess: "Unblocked successfully"
    },


    common: {
        tip: "Notice",
        confirm: "Confirm",
        cancel: "Cancel",
        refresh: "Refresh",
        actions: "Actions",
        success: "Operation Successful",
        error: "Request Failed",
    },

    authorize: {
        title: "Authorization ({name})",
        selectAll: "Select All",
        clear: "Clear",
        save: "Save",
        success: "Authorization successful!",

        // Common
        viewList: "View List",
        viewDetails: "View Details",
        addOrEdit: "Add / Edit",
        publishOrOff: "Publish / Unpublish",
        operate: "Operate",
        edit: "Edit",
        editRemark: "Edit Remark",
        createUser: "Create User",
        freezeUser: "Freeze User",
        editUserInfo: "Edit User Info",
        manualRecharge: "Manual Recharge",
        manualDeduct: "Manual Deduct",
        deleteWalletTx: "Delete Transaction Record",
        viewReserve: "View Reservation",

        // Original
        userList: "User List",
        setAssociate: "Set/Cancel Association",
        unblockUser: "Unblock User",
        download: "Download",
        freeze: "Freeze/Unfreeze",
        orgChart: "Organization Chart",

        ngpLockList: "Lockdown List",
        unblock: "Unblock",
        systemSettings: "System Settings",
        systemUser: "System User Management",
        systemUserList: "System User",
        rights: "Rights",

        CreateAndEdit: "Create / Edit",
        operation: "Enable / Disable",

        // New
        bannerManagement: "Banner Management",
        activityManagement: "Event Management",
        roomManagement: "Room Management",
        productManagement: "Product Management",
        productReservation: "Product Reservation",
        walletRecords: "Wallet Transaction Records",
        systemSetting: "System Setting",
        rightsManagement: "Rights Management",
    },

    RightsManagement: {
        pageTitle: "Rights",
        addPermission: "Add Permission",
        editPermission: "Edit Permission",
        table: {
            title: "Title",
            desc: "Description",
            createTime: "Create Time",
            status: "Status",
            operation: "Operation",
            enabled: "Enabled",
            disabled: "Disabled",
            authorize: "Authorize",
            edit: "Edit",
            delete: "Delete",
        },
        dialog: {
            addTitle: "Add Permission",
            editTitle: "Edit Permission",
            labelTitle: "Title",
            labelDesc: "Description",
            titlePlaceholder: "Title",
            descPlaceholder: "Optional",
            confirm: "Confirm",
            cancel: "Cancel",
        },
        confirm: {
            enable: "Please confirm to enable!",
            disable: "Please confirm to disable!",
            delete: "Please confirm to delete!",
        },
        message: {
            operationSuccess: "Operation successful!",
            deleteSuccess: "Deleted successfully",
            addSuccess: "Added successfully",
            editSuccess: "Edited successfully",
        },
        buttons: {
            confirm: "Confirm",
            cancel: "Cancel",
        },
        warning: "Warning",
    },
    SystemUser: {
        pageTitle: "System Users",
        addUser: "Add User",
        dialog: {
            addTitle: "Add User",
            editTitle: "Edit User",
            username: "Username",
            usernamePlaceholder: "Email format",
            password: "Password",
            passwordPlaceholder: "Password must include uppercase, lowercase, number, special char, 8-18 characters",
            auth: "Permission",
            authPlaceholder: "Select permission",
            desc: "Description",
            descPlaceholder: "Optional",
            confirm: "Confirm",
            cancel: "Cancel",
            confirmTitle: "Notice"
        },
        table: {
            username: "Account",
            authTitle: "Permission Title",
            desc: "Description",
            createTime: "Created At",
            loginTime: "Login Time",
            status: "Status",
            enabled: "Enabled",
            disabled: "Disabled",
            googleToken: "Google Token",
            bound: "Bound",
            unbound: "Unbound",
            blockStatus: "Block Status",
            blocked: "Blocked",
            normal: "Normal",
            operation: "Action",
            edit: "Edit",
            delete: "Delete",
            disable: "Disable",
            enable: "Enable",
            unbind: "Unbind",
            unblock: "Unblock"
        },
        confirm: {
            delete: "Please confirm deletion!",
            disable: "Please confirm disable!",
            enable: "Please confirm enable!",
            unblock: "Are you sure to unblock this user?",
            unbind: "Please confirm unbind!"
        },
        message: {
            addSuccess: "Added successfully!",
            editSuccess: "Edited successfully",
            deleteSuccess: "Deleted successfully",
            unblockSuccess: "Unblocked successfully!",
            unbindSuccess: "Unbound successfully!",
            operationSuccess: "Operation successful!"
        },
        rules: {
            usernameRequired: "Please enter username",
            usernameEmail: "Please enter a valid email",
            passwordRequired: "Please enter password",
            passwordPattern: "Password must include uppercase, lowercase, number, special char, 8-18 characters",
            authRequired: "Please select permission"
        }
    },
    UserList: {
        pageTitle: "User List",
        createUser: "Create User",
        search: "Search",
        clear: "Clear",
        download: "Download",
        cancel: "Cancel",
        submit: "Submit",
        downloadStart: "Download started",
        noData: "No data to download",
        downloading: "Downloading...",
        createSuccess: "User created successfully",
        createFail: "Failed to create user",
        account: "Account",
        username: "Username",
        name: "Name",
        birth: "Date of Birth",
        email: "Email",
        contact: "Contact",
        status: "Status",
        normal: "Normal",
        blocked: "Blocked",
        lastLogin: "Last Login",
        createTime: "Create Time",
        creator: "Creator",
        balance: "Balance",
        remark: "Remark",
        userDetails: "User Details",
        view: "View",
        startDate: "Start Date",
        endDate: "End Date",
        password: "Password",
        accountRequired: "Please enter account",
        passwordRequired: "Please enter password",
        birthPlaceholder: "Please select date of birth"
    },

    MemberUsersMore: {
        more: "User Details",
        modifyUser: "Modify User Information",
        copyUserInfo: "Copy User Info",
        userDetails: "User Information",
        walletRecords: "Wallet Transaction Records",
        userID: "Account",
        downloadUrl: "Download URL",
        memberAccount: "Member Account",
        password: "Password",
        name: "Name",
        username: "Username",
        birth: "Date of Birth",
        email: "Email",
        contact: "Contact",
        creator_name: "Creator",
        balance: "Balance",
        blockStatus: "Block Status",
        freezeStatus: "Freeze Status",
        associateAccount: "Associate Account",
        remark: "Remark",
        lastLoginTime: "Last Login",
        createTime: "Create Time",
        normal: "Normal",
        blocked: "Blocked",
        frozen: "Frozen",
        freeze: "Freeze",
        unfreeze: "Unfreeze",
        unblockUser: "Unblock User",
        unblock: "Unblock User",
        yes: "Yes",
        no: "No",
        setAssociateAccount: "Set Associate Account",
        cancelAssociateAccount: "Cancel Associate Account",
        modifyRemark: "Modify Remark",
        tip: "Tip",
        confirm: "Confirm",
        cancel: "Cancel",
        operateSuccess: "Operation successful",
        walletCreateTime: "Create Time",
        walletAmount: "Amount",
        walletPoints: "Points",
        walletProof: "Proof",
        walletOperator: "Operator",
        walletType: "Type",
        walletStatus: "Status",
        walletTypeRecharge: "Recharge",
        walletTypeDeduct: "Deduct",
        walletStatusNormal: "Normal",
        walletStatusDeleted: "Deleted",
        deleteOperator: "Deleted By",
        deleteTime: "Deleted Time",
        deleteWalletTx: "Delete",
        deleteWalletTxConfirm: "Are you sure you want to delete this transaction record?",

        // 新增手动充值/扣除弹窗
        manualDeposit: 'Manual Deposit',
        manualDeduct: 'Manual Deduct',
        amount: 'Amount',
        points: 'Points',
        proof: 'Proof',
        deductType: 'Deduct Type',
        deductType2: 'Backend Deduct',
        deductType3: 'Backend Deduct Dining Fee',
        operateFail: 'Operation Failed',
        reserveRecords: "Reservation Records",
        reserveId: "Reservation ID",
        reserveType: "Type",
        reserveName: "Name",
        reserveCover: "Cover",
        reserveStatus: "Status",
        reserveCreateTime: "Reservation Time",
        reserveUpdateTime: "Cancel Time",
        typeRoom: "Room",
        typeActivity: "Activity",
        typeDining: "Dining",
        typeView: "Viewing",
        statusValid: "Active",
        statusCancel: "Cancelled",
        statusExpired: "Ended or Unavailable",

        action: "Action",
        viewDetail: "View Details",
        reserveDetailTitle: "Reservation Details",
        peopleNumber: "People Number",
        reserveDate: "Reservation Date",
        reserveTime: "Reservation Time",
        pointsNumber: "Points",
        location: "Location",
        productPrice: "Product Price",
        productColor: "Product Color",
        productMaterial: "Product Material",
        close: "Close",

        proofRequired: "Please upload at least one proof",
        amountRequired: "Please enter amount",
        pointsRequired: "Please enter points",
        typeRequired: "Please select",

        timeRequired: "Please select date and time",
        Required: 'date and time',
    },
    copy: {
        success: "Copied successfully!",
        fail: "Copy failed, please copy manually.",
    },



    reminder: {
        PleaseEnter: 'Please enter',
        PleaseUpload: 'Please upload',
        PleaseSelect: 'Please select',
        MustBeGreaterThanZero: 'The number of registrants must be greater than 0',
    },
};